import { Component, OnInit, Input } from '@angular/core';
import { DataService } from '../../shared/services/dataService';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'app/shared/services/userService';
import { InterviewDetailsService, InterviewDetails, InterviewDocument } from 'app/shared/services/interviewDetailsService';
import { CaseData } from '../../shared/models/caseValidation';
import { FormControl, FormGroup, Validators } from '@angular/forms';


@Component({
    selector: 'app-interview-details',
    templateUrl: './interview-details.component.html',
    styleUrls: ['./interview-details.component.css']
})
export class InterviewDetailsComponent implements OnInit {
    @Input() caseId:string;
    @Input() isModifiable:boolean;
    @Input() interviewDetails:InterviewDetails;
    @Input() ParentFormGrp: FormGroup;
    public formCtrl: FormControl;

  show: boolean;

  constructor(
    private dataService: DataService,
    private interviewService: InterviewDetailsService,
    private userService:UserService,
    private router: Router, private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.show = (this.interviewDetails.FamilyInterviewsConducted === 'Yes') ? true : false;
    this.formCtrl = new FormControl(this.interviewDetails.NumberInterviewsConducted, [Validators.min(1), Validators.required]);
    this.ParentFormGrp.addControl('NumberFamilyInterviewsConducted', this.formCtrl);
    if (!this.show) {
      this.ParentFormGrp.removeControl('NumberFamilyInterviewsConducted');
    }
  }

  onChangeInterviewsConducted() {
    this.interviewDetails.FamilyInterviewsConducted = (this.interviewDetails.FamilyInterviewsConducted === 'Yes') ? 'No' : 'Yes';
    this.show = (this.interviewDetails.FamilyInterviewsConducted === 'Yes') ? true : false;
    CaseData.changeset['FamilyInterviews'] = this.interviewDetails.FamilyInterviewsConducted;
    if (!this.show) {
      this.ParentFormGrp.removeControl('NumberFamilyInterviewsConducted');
    } else {
      this.ParentFormGrp.addControl('NumberFamilyInterviewsConducted', this.formCtrl);
    }
    CaseData.OnChange();
  }

  update(event, dataKey: string) {
    switch(dataKey) {
      case 'NumberFamilyInterviewsConducted':
        this.formCtrl.setValue(event) ;
        this.ParentFormGrp.removeControl(dataKey);
        this.ParentFormGrp.addControl(dataKey, this.formCtrl);
        CaseData.changeset[dataKey] = this.interviewDetails.NumberInterviewsConducted = event;
        break;
      case 'FamilyInterviewsDetails':
        CaseData.changeset[dataKey] = this.interviewDetails.InterviewDescription;
        break;
    }
    CaseData.OnChange();
  }

  uploadFile(event) {
      var confirmationString = "Confirm that you intend to upload file:\n";

      let file;
      if(event.target.files && event.target.files[0]){
        file = event.target.files[0];
        confirmationString = confirmationString + file.name + "\n";
      }

      if (confirm(confirmationString) == true) {

        var re = /(?:\.([^.]+))?$/;
        var ext = re.exec(file.name)[1];
        var fileName = file.name.replace(`.${ext}`, '');

        const doc = new InterviewDocument();
        doc.FileName = fileName;
        doc.Extension = ext;
        doc.FileSize = file.size;
        doc.UploadDate = new Date();

        this.interviewService.uploadInterviewFile(this.caseId, file)
            .then(res => {
              if(res.Success){
                if(!this.interviewDetails.InterviewDocuments)  this.interviewDetails.InterviewDocuments = [];
                this.interviewDetails.InterviewDocuments.push(doc);
                CaseData.changeset["FamilyInterviewDocuments"] = JSON.stringify(this.interviewDetails.InterviewDocuments);
                CaseData.OnChange();
              }else{
                alert(res.Message);
              }
            })
            .catch(error => alert('An error occurred\n' + error.json()));
      }
      event.target.value = '';
    }

    downloadFile(event, document) {
      this.interviewService.downloadInterviewFile(this.caseId, document.FileName)
      .then(res => {
        this.downloadBlob(res, document.FileName);
      })
    }

    deleteFile(event, document) {
      var confirmationString = "Confirm that you intend to delete this file:";

        if (confirm(confirmationString) == true) {
        this.interviewService.deleteInterviewFile(this.caseId, document.FileName)
            .then(res => {
              this.interviewDetails.InterviewDocuments = this.interviewDetails.InterviewDocuments.filter(doc => doc !== document);
              CaseData.changeset["FamilyInterviewDocuments"] = JSON.stringify(this.interviewDetails.InterviewDocuments);
              CaseData.OnChange();
            })
            .catch(error => alert('An error occurred\n' + error.json()));
        }
    }

    downloadBlob(data: any, name: any) {
      let newBlob = new Blob([data], { type: data.type });
      if (typeof window.navigator.msSaveBlob !== 'undefined'){ //Stupid windows only hack (IE and Edge)
        window.navigator.msSaveBlob(newBlob, name);
      } else {
        let a = document.createElement("a");
        document.body.appendChild(a);
        a.setAttribute("style", "display: none");
        let url = window.URL.createObjectURL(newBlob);
        a.href = url;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    }
}

